import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-953f5f50"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "contacts-table-container max-w-full h-full overflow-auto bg-background dark:bg-background-dark shadow-card dark:shadow-card-dark" };
const _hoisted_2 = {
    class: "contacts-table table w-auto min-w-full bg-background dark:bg-background-dark",
    "data-test": "contacts-table"
};
const _hoisted_3 = {
    key: 0,
    class: "w-[80px] h-full absolute left-none z-[1] shadow-contextual dark:shadow-contextual-dark"
};
const _hoisted_4 = { class: "contacts-table-head sticky top-none z-[2]" };
const _hoisted_5 = { class: "row flex w-auto clear-both head-row h-[34px] typography-caption-semibold bg-background dark:bg-background-dark theme-border-outline-variant dark:theme-border-outline-variant-dark !border-0 !border-b-1" };
const _hoisted_6 = {
    ref: "checkboxCellIntersectionPartRef",
    class: "w-none h-full"
};
const _hoisted_7 = { class: "flex flex-row items-center w-full h-full" };
const _hoisted_8 = { class: "h-full flex items-center" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header-cell inline-block min-w-0 grow" }, null, -1));
const _hoisted_10 = {
    key: 1,
    class: "contacts-table-body"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "flex flex-row items-start w-full h-full pt-[14px]" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "cell inline-block min-w-0 grow" }, null, -1));
const _hoisted_14 = {
    key: 0,
    class: "row flex grow w-full clear-both"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "cell inline-block min-w-0 grow" }, null, -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row flex grow w-full clear-both" }, null, -1));
const _hoisted_17 = {
    key: 0,
    class: "empty sticky left-none p-md text-center typography-body-2-regular",
    "data-test": "table-empty"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_or_checkbox = _resolveComponent("or-checkbox");
    const _component_contacts_table_column_header_cell = _resolveComponent("contacts-table-column-header-cell");
    const _component_or_skeleton_rect = _resolveComponent("or-skeleton-rect");
    const _component_contacts_table_data_cell = _resolveComponent("contacts-table-data-cell");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isShowingCheckboxesColumnShadow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, null, 512),
                    (!_ctx.isCheckboxHidden)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["header-cell inline-block px-xl action-select flex-none theme-border-outline-variant dark:theme-border-outline-variant-dark !border-0 sticky z-[1] left-none bg-background dark:bg-background-dark", { '!border-r-1': !_ctx.isHeaderRowLoading }])
                        }, [
                            _createElementVNode("div", _hoisted_7, [
                                (_ctx.areCheckboxesVisible)
                                    ? (_openBlock(), _createBlock(_component_or_checkbox, {
                                        key: 0,
                                        indeterminate: _ctx.isAnySelected && !_ctx.isAllSelected,
                                        "model-value": _ctx.isAnySelected,
                                        "is-disabled": _ctx.isEmpty,
                                        "onUpdate:modelValue": _ctx.handleSelectAll
                                    }, null, 8, ["indeterminate", "model-value", "is-disabled", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 2))
                        : _createCommentVNode("", true),
                    (!_ctx.isHeaderRowLoading)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.fieldSchemasToShow, (column) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: `${column.label}_${column.machine_name}`,
                                class: "header-cell inline-block text-ellipsis text-start whitespace-nowrap theme-border-outline-variant dark:theme-border-outline-variant-dark !border-0 !border-r-1",
                                "data-test": "header-cell",
                                style: _normalizeStyle(_ctx.dataCellCss[column.id])
                            }, [
                                _createVNode(_component_contacts_table_column_header_cell, {
                                    "column-key": column.id,
                                    value: column.label,
                                    width: _ctx.storedColumnsInfo[column.id].width,
                                    "can-be-resized-now": !_ctx.isAnyResizing,
                                    "can-be-ordered": _ctx.typesToOrder.includes(column.type),
                                    "order-mode": _ctx.columnToOrderBy === column.id ? _ctx.orderMode : null,
                                    onWidthChange: _ctx.onColumnHeaderWidthChange,
                                    onBarDragStart: _ctx.onColumnHeaderWidthChangeStart,
                                    onBarDragEnd: _ctx.onColumnHeaderWidthChangeEnd,
                                    onOrder: ($event) => (_ctx.onOrderChange(column.id, $event))
                                }, null, 8, ["column-key", "value", "width", "can-be-resized-now", "can-be-ordered", "order-mode", "onWidthChange", "onBarDragStart", "onBarDragEnd", "onOrder"])
                            ], 4));
                        }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingColumnsKeys, (key) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: key,
                                class: "header-cell inline-block pl-sm text-ellipsis text-start whitespace-nowrap border-y-0",
                                style: _normalizeStyle({ width: _ctx.loadingColumnsWidths[key] }),
                                "data-test": "header-cell"
                            }, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_or_skeleton_rect, {
                                        width: 96,
                                        height: 21,
                                        class: "max-w-full"
                                    })
                                ])
                            ], 4));
                        }), 128)),
                    _hoisted_9
                ])
            ]),
            (!_ctx.isShowingHeaderOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (!_ctx.areContactsLoading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: contact.id,
                                    class: _normalizeClass(["row flex w-auto clear-both contact-row cursor-pointer typography-body-2-regular theme-border-outline-variant dark:theme-border-outline-variant-dark !border-0 !border-b-1 hover:bg-primary-opacity-0-08 dark:hover:bg-primary-opacity-0-08-dark [&_.checkbox-bg]:hover:bg-primary-opacity-0-08 [&_.checkbox-bg]:dark:hover:bg-primary-opacity-0-08-dark", {
                                            'bg-primary-opacity-0-12 dark:bg-primary-opacity-0-12-dark': _ctx.selected.includes(contact.id) && _ctx.singleSelected !== contact.id,
                                            'bg-primary-opacity-0-16 dark:bg-primary-opacity-0-16-dark': _ctx.singleSelected === contact.id,
                                        }]),
                                    "data-test": "contact-row",
                                    onClick: ($event) => (_ctx.$emit('view', contact.id))
                                }, [
                                    (!_ctx.isCheckboxHidden)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "cell inline-block select-action flex-none sticky z-[1] left-none bg-background dark:bg-background-dark",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                                        }, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["checkbox-bg w-full h-full px-xl", {
                                                        'bg-primary-opacity-0-12 dark:bg-primary-opacity-0-12-dark': _ctx.selected.includes(contact.id) && _ctx.singleSelected !== contact.id,
                                                        'bg-primary-opacity-0-16 dark:bg-primary-opacity-0-16-dark': _ctx.singleSelected === contact.id,
                                                    }])
                                            }, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    (_ctx.areCheckboxesVisible)
                                                        ? (_openBlock(), _createBlock(_component_or_checkbox, {
                                                            key: 0,
                                                            "model-value": _ctx.selected.includes(contact.id),
                                                            "onUpdate:modelValue": ($event) => (_ctx.handleSelect(contact.id))
                                                        }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldSchemasToShow, (column) => {
                                        var _a, _b;
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: column.id,
                                            "data-test": "contact-cell",
                                            class: _normalizeClass(["cell inline-block pl-sm whitespace-nowrap overflow-hidden text-ellipsis", { 'border-r-2 border-r-primary-hover dark:border-r-primary-hover-dark': _ctx.resizingColumnKey === column.id }]),
                                            style: _normalizeStyle(_ctx.dataCellCss[column.id])
                                        }, [
                                            _createVNode(_component_contacts_table_data_cell, {
                                                type: column.type,
                                                value: (_b = (_a = contact.fieldValues[column.id]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : contact[column.id],
                                                class: "px-sm py-sm+ overflow-hidden text-ellipsis h-full"
                                            }, null, 8, ["type", "value"])
                                        ], 6));
                                    }), 128)),
                                    _hoisted_13
                                ], 10, _hoisted_11));
                            }), 128)),
                            (!_ctx.isEmpty)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                : _createCommentVNode("", true)
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingRowsKeys, (rowKey) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: rowKey,
                                    class: "row flex w-auto clear-both contact-row typography-body-2-regular theme-border-outline-variant dark:theme-border-outline-variant-dark !border-0 !border-b-1"
                                }, [
                                    (!_ctx.isCheckboxHidden)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "cell inline-block select-action flex-none border-r-1 border-r-transparent sticky z-[1] left-none bg-background dark:bg-background-dark",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                                        }, [
                                            (_ctx.areCheckboxesVisible)
                                                ? (_openBlock(), _createBlock(_component_or_checkbox, {
                                                    key: 0,
                                                    class: "w-full h-full px-xl",
                                                    "is-disabled": ""
                                                }))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingColumnsKeys, (columnKey) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: columnKey,
                                            class: "cell md:h-[45px] h-[72px] inline-block pl-sm whitespace-nowrap overflow-hidden text-ellipsis",
                                            style: _normalizeStyle({ width: _ctx.loadingColumnsWidths[columnKey] })
                                        }, [
                                            _createVNode(_component_or_skeleton_rect, {
                                                width: 96,
                                                height: 21,
                                                class: "mt-[12px] max-w-full"
                                            })
                                        ], 4));
                                    }), 128)),
                                    _hoisted_15
                                ]));
                            }), 128)),
                            _hoisted_16
                        ], 64))
                ]))
                : _createCommentVNode("", true)
        ]),
        (!_ctx.isLoading && _ctx.isEmpty && !_ctx.isShowingHeaderOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.emptyTableText), 1))
            : _createCommentVNode("", true)
    ]));
}
